import { render, staticRenderFns } from "./AlertWrapper.vue?vue&type=template&id=12175240&scoped=true&"
import script from "./AlertWrapper.vue?vue&type=script&lang=js&"
export * from "./AlertWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12175240",
  null
  
)

export default component.exports